<script setup lang="ts">
import { provide, ref } from "vue";

import SideNav from "../navigation/SideNav.vue";
import TopBar from "../navigation/TopBar.vue";

const hideSidebar = ref(false);
const isCollapsed = ref(false);

function toggleCollapsed() {
	isCollapsed.value = !isCollapsed.value;
}

// Used by "404 Page Not Found" components for hiding the sidebar
provide("hideSidebar", hideSidebar);
</script>

<template>
	<div
		class="grid h-screen w-full"
		:class="{
			'pl-0': $route.meta.hideSideNav,
			'md:pl-16': !$route.meta.hideSideNav && !hideSidebar && isCollapsed,
			'md:pl-64': !$route.meta.hideSideNav && !hideSidebar && !isCollapsed,
		}"
	>
		<SideNav
			v-if="!$route.meta.hideSideNav && !hideSidebar"
			@toggle-collapsed="toggleCollapsed"
			:is-collapsed="isCollapsed"
		/>
		<main class="bg-muted grid grid-rows-[3rem_minmax(0,1fr)]">
			<TopBar :has-sidebar="!hideSidebar" />
			<div class="h-[calc(100vh-3rem)] overflow-x-hidden overflow-y-auto">
				<slot />
			</div>
		</main>
	</div>
</template>
